export default "__VITE_ASSET__CB$QJHnu__"